import twitterIcon from '../../assets/img/social-networks-icons/twitt.svg';
import facebookIcon from '../../assets/img/social-networks-icons/faceb.svg';
import whatsAppIcon from '../../assets/img/social-networks-icons/whatsapp.svg';
import spritesIcons from '../../assets/img/social-networks-icons/css_sprites.png';
import emailIcon from '../../assets/img/social-networks-icons/email.svg';
import googlePlayBadge from '../../assets/img/google-play-badge.png';
import appStoreBadge from '../../assets/img/app-store-badge.png';

export default {
    mobileScreenSize: 768,
    mp4Ext: 'mp4',
    hlsExt: 'm3u8',
    'mp4': 'video/mp4',
    'm3u8': 'application/x-mpegURL',
    highlight: 'Highlight',
    clip: 'Clip',
    appID: 'WebPlayer',
    Facebook: 'Facebook',
    WhatsApp: 'WhatsApp',
    banners: [
        {
            name: 'android',
            alt: 'Get it on Google Play',
            imageSrc: googlePlayBadge,
        },
        {
            name: 'ios',
            alt: 'Download on the App Store',
            imageSrc: appStoreBadge
        }
    ],
    socialSharing: {
        TWITTER: { name: 'twitt', label: 'Twitter', img: twitterIcon },
        FACEBOOK: { name: 'faceb', label: 'Facebook', img: facebookIcon },
        WHATS_APP: { name: 'whatsapp', label: 'WhatsApp', img: whatsAppIcon },
        REDDIT: { name: 'reddit', label: 'Reddit', img: spritesIcons, positionX: 0, positionY: 0 },
        LINKEDIN: { name: 'linkedin', label: 'Linkedin', img: spritesIcons, positionX: -40, positionY: 0 },
        PINTEREST: { name: 'pinterest', label: 'Pinterest', img: spritesIcons, positionX: -80, positionY: 0 },
        SKYPE: { name: 'skype', label: 'Skype', img: spritesIcons, positionX: 0, positionY: -60 },
        EVERNOTE: { name: 'evernote', label: 'Evernote', img: spritesIcons, positionX: -40, positionY: -60 },
        TUMBLR: { name: 'tumblr', label: 'Tumblr', img: spritesIcons, positionX: -80, positionY: -60 },
        DIGG: { name: 'digg', label: 'Digg', img: spritesIcons, positionX: -120, positionY: 0 },
        STUMBLEUPON: { name: 'stumbleupon', label: 'StumbleUpon', img: spritesIcons, positionX: -120, positionY: -60 },
        FLIPBOARD: { name: 'flipboard', label: 'Flipboard', img: spritesIcons, positionX: -160, positionY: 0 },
        RENREN: { name: 'renren', label: 'Renren', img: spritesIcons, positionX: -160, positionY: -60 },
        VIBER: { name: 'viber', label: 'Viber', img: spritesIcons, positionX: 0, positionY: -120 },
        GOOGLE_BOOKMARKS: { name: 'googlebookmarks', label: 'Google bookmarks', img: spritesIcons, positionX: -39, positionY: -120 },
        HACKERNEWS: { name: 'hackernews', label: 'Hackernews', img: spritesIcons, positionX: -80, positionY: -120 },
        BUFFER: { name: 'buffer', label: 'Buffer', img: spritesIcons, positionX: -119, positionY: -120 },
        WEIBO: { name: 'weibo', label: 'Weibo', img: spritesIcons, positionX: -158, positionY: -120 },
        TELEGRAM: { name: 'telegram', label: 'Telegram', img: spritesIcons, positionX: -200, positionY: 0 },
        LINE: { name: 'line', label: 'Line', img: spritesIcons, positionX: -200, positionY: -59 },
        EMAIL: { name: 'email', label: 'Email', img: emailIcon },
        KAKAO: { name: 'kakao', label: 'Kakao', img: spritesIcons, positionX: -200, positionY: -120 }
    },
    errorMessages: {
        webSDKLoading: 'There was an error when trying to load the player',
        webSDKPlaying: 'Something went wrong during native playback. Please try again later',
        sharedLinkCreating: 'There was an error when trying to create shared link'
    }
};
